import { jsx } from "react/jsx-runtime";
import CodeIcon from "@mui/icons-material/Code";
import { validateTidalLicense } from "../../base/index.js";
function Code(props) {
  return /* @__PURE__ */ jsx(
    CodeIcon,
    {
      "data-testid": "Code",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Code",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
Code.tidalIconMeta = {
  categories: "devices,photos",
  name: "Code"
};
validateTidalLicense();
export {
  Code
};
//# sourceMappingURL=Code.js.map
